export enum CustomerAccountType {
    PRIVATE = 'PRIVATE',
    COMPANY = 'COMPANY',
}
